import type { CircleRadius } from '../useMapCircleRadius.types';

/**
 * Calculates the bounding box coordinates for a circle given center and radius in miles.
 * Returns southwest and northeast corners that can be used to fit the map bounds.
 */
export function getCircleBounds(circleRadius: CircleRadius) {
  const { centerLat, centerLng, radiusInMiles } = circleRadius;

  // For latitude: 1 degree ≈ 69 miles
  const latRadius = radiusInMiles / 69;

  // For longitude: varies by latitude, but we'll use an approximation
  const lngRadius = radiusInMiles / (69 * Math.cos((centerLat * Math.PI) / 180)); // prettier-ignore

  const southwestLat = centerLat - latRadius;
  const southwestLng = centerLng - lngRadius;
  const northeastLat = centerLat + latRadius;
  const northeastLng = centerLng + lngRadius;

  return {
    southwest: {
      latitude: southwestLat,
      longitude: southwestLng,
      lat: southwestLat,
      lng: southwestLng,
    },
    northeast: {
      latitude: northeastLat,
      longitude: northeastLng,
      lat: northeastLat,
      lng: northeastLng,
    },
  };
}
